export default function ShirtIcon({ color, strokeColor = "white" }: { color?: string; strokeColor?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="49"
      viewBox="0 0 54 49"
      fill="none"
    >
      <path
        d="M18.1035 0.709961V0.710938L18.1094 0.714844C18.1094 0.714844 18.1173 0.718979 18.1279 0.725586C18.1388 0.732364 18.1539 0.74232 18.1729 0.753906C18.2107 0.77704 18.2641 0.809479 18.332 0.849609C18.4684 0.930115 18.6642 1.04172 18.9092 1.1748C19.3986 1.44067 20.0899 1.79241 20.915 2.14258C22.5532 2.83774 24.7729 3.55363 27.001 3.55371C29.2292 3.55371 31.4495 2.83697 33.0879 2.1416C33.9132 1.79129 34.6053 1.44061 35.0947 1.1748C35.3396 1.04178 35.5347 0.929972 35.6709 0.849609C35.739 0.809423 35.7924 0.776933 35.8301 0.753906L35.8877 0.717773L35.8955 0.712891L35.8975 0.713867L53.2891 9.23535V9.23926L52.2188 16.7441C52.0201 18.1323 50.8065 19.1845 49.4053 19.1846H44.7646V44.7637C44.7644 46.3291 43.4883 47.6052 41.9229 47.6055H12.0801C10.5145 47.6054 9.23852 46.3291 9.23828 44.7637V19.1846H4.59766C3.28288 19.1846 2.13506 18.2604 1.83301 17.001L1.78418 16.7441L0.709961 9.23926H0.710938V9.23828L0.712891 9.23633L18.1025 0.710938L18.1035 0.709961Z"
        fill={color || "#E6052E"}
        stroke={strokeColor}
        strokeWidth={strokeColor === "white" ? "1.42105" : "2"}
      />
    </svg>
  );
}
